import { useState } from 'react'
import classNames from 'classnames'

import type { BaseProps as ItemProps, AllowedVariants } from './AccordionItem'
import AccordionItem from './AccordionItem'

import style from './style.scss'

type Props = {
  className?: string
  items: ItemProps[]
  showBottomBorders?: boolean
  variant: AllowedVariants
}

function Accordion(props: Props) {
  const [expandedIndex, setIndex] = useState(-1)

  const handleToggleExpanded = (index: number) => {
    const newIndex = index === expandedIndex ? -1 : index
    setIndex(newIndex)
  }

  const { className, items, showBottomBorders = false, variant } = props

  return (
    <ul
      className={classNames(style[variant], className)}
      data-testid='accordion'
    >
      {items.map((item, index) => (
        <AccordionItem
          key={item.summary}
          {...item}
          active={index === expandedIndex}
          index={index}
          showBottomBorders={showBottomBorders}
          toggleActive={handleToggleExpanded}
          variant={variant}
        />
      ))}
    </ul>
  )
}

export default Accordion
